var path = '/formViewer/structure/repeatingRow/repeatingRowPlaceholder.tpl.html';
var html = "<ui-repeating-row row=\"row\"\n                  hide-row-numbers=\"hideRowNumbers\"\n                  configurable=\"configurable\"></ui-repeating-row>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;